<template>
  <div class="gf_plan-tooltip">
    <template v-if="false">
      <i class="icon icon-help" v-popover:tooltip.right="$t('Monthly templates for events')"></i>
    </template>
    <template v-if="true">
      <div class="gf_plan-tooltip__section">
        <img class="gf_plan-tooltip__section-image" v-if="image" :src="$t(image)" />
        <div class="gf_plan-tooltip__section__box" :class="{ 'gf_plan-tooltip__section__box--dark': tooltipDark }">
          <div class="gf_plan-tooltip__section__box--label">{{ $t(title) }} <BetaTag v-if="isBeta" /></div>
          <div class="gf_plan-tooltip__section__box--desc">
            {{ $t(description) }}
          </div>
        </div>
      </div>
      <i class="icon icon-help"></i>
    </template>
  </div>
</template>

<script>
import BetaTag from "./PricingPlanCompare/BetaTag.vue";
export default {
  name: "PLanPackItem",
  components: { BetaTag },
  props: {
    type: String,
    title: String,
    description: String,
    image: String,
    isBeta: {
      type: Boolean,
      default: false
    },
    tooltipDark: {
      type: Boolean,
      default: true
    }
  },
 
};
</script>

<style lang="scss" scoped>
.gf_plan-tooltip {
  height: fit-content;
  display: flex;
  align-items: center;
  position: relative;
  position: absolute;
  top: 2.5px;
  .icon {
    width: 14px;
    font-size: 14px;
    color: map-get($text-light-mode, "low-contrast");
    cursor: pointer;
    &:hover {
      color: map-get($text-light-mode, "high-contrast");
    }
  }
  &__section {
    display: none;
    position: absolute;
    bottom: 22px;
    left: calc(0px - (342px / 2) + 7.5px);
    width: 342px;
    background: map-get($hybrid-shade-light, "100");
    border-radius: 4px;
    flex-direction: column;
    z-index: 3;
    filter: drop-shadow(0px -2px 8px rgba(0, 0, 0, 0.06)) drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.12));
    &-image {
      width: 100%;
      height: 153px;
    }
    &__box {
      padding: 11px 15px;
      z-index: 2;
      position: relative;
      background: map-get($hybrid-shade-light, "100");
      border: 1px solid #ededed;
      border-bottom-right-radius: 4px;
      border-bottom-left-radius: 4px;
      &::after {
        content: " ";
        position: absolute;
        bottom: -4px;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 4px solid map-get($hybrid-shade-light, "100");
      }
      &::before {
        content: " ";
        position: absolute;
        bottom: -25px;
        left: calc(50% - 10px);
        width: 20px;
        height: 25px;
        cursor: pointer;
      }
      &--label {
        font-weight: 500;
        font-size: 16px;
        line-height: 150%;
        color: map-get($text-light-mode, "high-contrast");
        margin-bottom: 4px;
      }
      &--desc {
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: map-get($text-light-mode, "low-contrast");
      }
      &--dark {
        background: map-get($hybrid-shade-dark, "200");
        border: 1px solid map-get($hybrid-shade-dark, "200");
        &::after {
          border-top: 4px solid map-get($hybrid-shade-dark, "200");
        }
        .gf_plan-tooltip__section__box--label {
          color: map-get($hybrid-shade-light, "100");
          display: flex;
          align-items: center;
        }
        .gf_plan-tooltip__section__box--desc {
          color: map-get($text-dark-mode, "high-contrast");
        }
      }
    }
  }
  &:hover {
    .gf_plan-tooltip__section {
      display: flex;
    }
  }
}
</style>
